import { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { LockClosedIcon,CodeBracketSquareIcon,IdentificationIcon,CogIcon,PhoneIcon,GlobeAltIcon,SparklesIcon,SunIcon,ShoppingCartIcon,TruckIcon, HeartIcon, Bars3Icon,CpuChipIcon, DocumentTextIcon,BoltIcon, ShieldCheckIcon, ChevronDownIcon, BuildingOfficeIcon, BookOpenIcon, UserGroupIcon, XMarkIcon } from '@heroicons/react/24/outline';
import GenXZIcon from '../GENXZAINEW.png';
import { useState } from 'react';
import { Link } from 'react-router-dom';

// const lists = [
//   {
//     name: 'Pricing',
//     sublinks: [
//       { name: 'Pricing Plans', href: '#' },
//       { name: 'Custom Solutions', href: '#' },
//       { name: 'Discounts & Offers', href: '#' },
      
//     ],
//   },
//   {
//     name: 'Partners',
//     sublinks: [
//       { name: 'Become a Partner', href: '#' },
//       { name: 'Partner Program', href: '#' },
//       { name: 'Integration Partners', href: '#' },
//       { name: 'Reseller Partners', href: '#' },
//     ],
//   },
//   {
//     name: 'Company',
//     sublinks: [
//       { name: 'About Us', href: '#' },
//       { name: 'Careers', href: '#' },
//       { name: 'Contact', href: '#' },
//     ],
//   },
// ];

  
const navigation = [
  { name: 'Careers', href: '/careers' },
];

const solutions = [
  // {
  //   name: 'Inbox',
  //   description: 'Get a better understanding of where your traffic is coming from.',
  //   href: '#',
  //   icon: InboxIcon,
  // },
  // {
  //   name: 'Messaging',
  //   description: 'Speak directly to your customers in a more meaningful way.',
  //   href: '#',
  //   icon: ChatBubbleLeftEllipsisIcon,
  // },
  // {
  //   name: 'Live Chat',
  //   description: "Your customers' data will be safe and secure.",
  //   href: '#',
  //   icon: ChatBubbleLeftIcon,
  // },
 
  {
    name: 'Design Simulation of Quantum Dots',
    // description: 'Our platform integrates nanoscale quantum dot modeling with automated design tools to simulate physical behavior under varying conditions-ensuring optimized placement and energy efficiency.',
    href: '/solutions/design-simulation-quantum-dots',
    icon: CpuChipIcon, // Represents technology and advanced tools, suitable for a tech stack
  },
  {
    name: 'AI Middleware for Tuning',
    // description: 'Reinforcement Learning (RL) and Deep Learning (DL) algorithms continuously adjust control voltages and parameters, eliminating the need for manual intervention. This middleware dynamically responds to environmental changes like drift, noise, and decoherence.',
    href: '/solutions/ai-middleware-for-tuning',
    icon: SparklesIcon, // Represents technology and advanced tools, suitable for a tech stack
  },
  
  {
    name: 'Automated Calibration and Control',
    // description: 'Real-time system feedback loops allow for self-calibration, reducing operational latency and energy overhead. AI agents learn optimal control policies, accelerating tuning times by over 90%.',
    href: '/solutions/automated-calibration-control',
    icon: CogIcon, // Represents technology and advanced tools, suitable for a tech stack
  },
  
  {
    name: 'Quantum Skin for Intelligent Infrastructure',
    // description: 'With your partnership, you’ll receive full access to our well-documented source code, including SCSS, JavaScript, and API integration files for customization and expansion.',
    href: '/solutions/quantum-skin-for-intelligent-infra',
    icon: CodeBracketSquareIcon, // Represents code and technical access, ideal for source code
  },
  // {
  //   name: 'Automated Development Workflow',
  //   description: 'Focus on innovation while we handle tedious tasks. Our dynamic workflow enhances UI/UX, creating modular, maintainable code with AI-driven features for faster development.',
  //   href: '#',
  //   icon: ArrowPathRoundedSquareIcon, // Represents automated workflows and circular processes
  // },
  // {
  //   name: 'Seamless API Integrations',
  //   description: 'Easily integrate our advanced services with your existing systems. Our solutions are flexible and scalable, supporting AI, GPS services, or custom automation tools.',
  //   href: '/solutions/seamless-api-integration',
  //   icon: LinkIcon, // Represents seamless connections and integrations
  // },
  // {
  //   name: 'Advanced GPS & Tracking Services',
  //   description: 'Gain access to advanced GPS services, real-time location tracking, AI-powered automation tools, and GenAI ready to be implemented in your applications immediately.',
  //   href: '/solutions/advance-gps-tracking',
  //   icon: MapPinIcon, // Represents location services, suitable for GPS and AI integration
  // },
  // {
  //   name: 'AI Driven Solutions',
  //   description: "Enhance your business efficiency with AI-powered automation, innovate and deliver smarter, and seamless integrations.",
  //   href: '/solutions/ai-driven',
  //   icon: SparklesIcon,
  // },  
  // {
  //   name: 'Generative AI for Audio processing and Automation',
  //   description:
  //     'Utilize cutting-edge Generative AI for automation with audio processing, streamline production workflows, and deliver dynamic, personalized audio based interaction.',
  //     href: '/solutions/genai-and-automation',
  //     icon: MicrophoneIcon,
  // },
];


const ourIndustries= [
  {
    name: 'Healthcare',
    // description: 'Enhance patient care and operational efficiency with AI-powered automation and real-time GPS tracking for medical logistics.',
    href: '/industries/healthcare',
    icon: HeartIcon // Represents healthcare and patient services
  },
  {
    name: 'Environmental & Infrastructure Sensing',
    // description: 'Optimize routes, reduce delivery times, and enhance inventory management with AI and GPS-driven logistics solutions.',
    href: '/industries/environment-and-infra-sensing',
    icon: SunIcon // Represents logistics, supply chain, and transportation
  },
  {
    name: 'Quantum-AI Edge IoT Devices',
    // description: 'Optimize routes, reduce delivery times, and enhance inventory management with AI and GPS-driven logistics solutions.',
    href: '/industries/quantum-ai-edge-iot-devices',
    icon: CpuChipIcon // Represents logistics, supply chain, and transportation
  },
  {
    name: 'Defense & Anti-Jamming Systems',
    // description: 'Optimize routes, reduce delivery times, and enhance inventory management with AI and GPS-driven logistics solutions.',
    href: '/industries/defense-and-anti-jamming-systems',
    icon: ShieldCheckIcon // Represents logistics, supply chain, and transportation
  },
  {
    name: 'Data Security',
    // description: 'Optimize routes, reduce delivery times, and enhance inventory management with AI and GPS-driven logistics solutions.',
    href: '/industries/data-security',
    icon: LockClosedIcon // Represents logistics, supply chain, and transportation
  },
  {
    name: 'Advanced Drone Technology',
    // description: 'Optimize routes, reduce delivery times, and enhance inventory management with AI and GPS-driven logistics solutions.',
    href: '/industries/advanced-drone-technology',
    icon: BoltIcon // Represents logistics, supply chain, and transportation
  },
  // {
  //   name: 'Logistics & Supply Chain',
  //   // description: 'Optimize routes, reduce delivery times, and enhance inventory management with AI and GPS-driven logistics solutions.',
  //   href: '/industries/logistic-and-supply',
  //   icon: TruckIcon // Represents logistics, supply chain, and transportation
  // },
  // {
  //   name: 'Retail & E-commerce',
  //   // description: 'Boost sales and customer satisfaction with AI-driven demand forecasting, automated customer support, and GPS-powered delivery tracking.',
  //   href: '/industries/retail-and-ecommerce',
  //   icon: ShoppingCartIcon // Represents retail, e-commerce, and customer service
  // },
  // {
  //   name: 'Agriculture & Farming',
  //   // description: 'Leverage AI and GPS technology for precision farming, real-time monitoring, and automated resource management to increase crop yields.',
  //   href: '/industries/agriculture-and-farming',
  //   icon: SunIcon // Represents agriculture, sustainability, and eco-friendly solutions
  // },
  // {
  //   name: 'Smart Cities',
  //   // description: 'Enable smarter urban infrastructure with AI-driven traffic management, public service automation, and GPS-enabled resource allocation.',
  //   href: '/industries/smartcities',
  //   icon: BuildingOfficeIcon // Represents smart city planning and infrastructure
  // },
  // {
  //   name: 'AI-Driven Businesses',
  //   // description: 'Automate tasks and optimize operations with AI-powered insights.',
  //   href: '/industries/ai-driven-businesses',
  //   icon: SparklesIcon, // Represents AI, technology, and automation
  // }    
];

// Example Data for 'Knowledge Hub'
// const knowledgeHub = [
  
//   { name: 'Guides & Tutorials', description: 'Step-by-step instructions to help you get the most out of our tools.', href: '#', icon: QuestionMarkCircleIcon },
//   {
//     name: 'Case Studies',
//     description: 'Learn how businesses have leveraged our solutions to achieve success.',
//     href: '#',
//     icon: ChartBarIcon, // Represents data and success stories
//   },
//   // {
//   //   name: 'Guides & Tutorials',
//   //   description: '',
//   //   href: '#',
//   //   icon: BookOpenIcon  // VideoCameraIcon, // Represents instructional and educational content
//   // },
//   // {
//   //   name: 'Webinars & Video Tutorials',
//   //   description: 'Watch on-demand webinars and video tutorials to deepen your understanding.',
//   //   href: '#',
//   //   icon: VideoCameraIcon, // Represents video-based learning
//   // },
//   {
//     name: 'FAQs',
//     description: 'Find answers to frequently asked questions about our products.',
//     href: '#',
//     icon: QuestionMarkCircleIcon, // Represents questions and answers
//   },
//   {
//     name: 'Product Documentation',
//     description: 'Detailed guides and API documentation for developers and users.',
//     href: '#',
//     icon: CodeBracketSquareIcon, // Represents technical documentation and APIs
//   },
//   {
//     name: 'Industry Reports',
//     description: 'Stay updated with the latest reports and insights in the industry.',
//     href: '#',
//     icon: NewspaperIcon, // Represents industry reports and updates
//   },
//   {
//     name: 'Data Protection and Info Security',
//     description: 'We use advanced security practices to protect your data and ensure your business stays secure.',
//     href: '#',
//     icon: ShieldCheckIcon, // Represents security and protection
//   },
//   {
//     name: 'News & Events',
//     description: 'Stay informed about the latest company news and upcoming events.',
//     href: '#',
//     icon: CalendarIcon, // Represents events and announcements
//   }
  
// ];

// Example Data for 'ourInnovations'
const ourInnovations = [

  {
    name: 'Edge-deployable quantum sensing platform',
    href: '/innovations/edge-deployable-quantum-sensing-platform', 
    icon: CodeBracketSquareIcon
  },
  { name: 'Self-Adaptive Quantum Systems', 
    // description: 'Video explainer: show DL + RL automating gate tuning in real-time and Reduce human tuning by 90% using autonomous feedback systems', 
    href: '/innovations/self-adaptive-quantum-systems', 
    icon: BoltIcon 
  },
  
  { name: 'Quantum-AI Design Platform', 
    // description: 'Quantum-AI Design Platform by GenXZAI is a next-generation tool that unites quantum dot engineering with intelligent AI systems. It enables researchers, engineers, and innovators to design, simulate, and optimize quantum dot architectures using reinforcement learning and deep learning', 
    href: '/innovations/quantum-ai-design-platform', 
    icon: CpuChipIcon },

  {
    name: 'Quantum Security',
    href: '/innovations/quantum-security', 
    icon: IdentificationIcon
  },
  // { name: 'Our Team', description: 'Get to know the people behind our success.', href: '/aboutus/our-team', icon: UserGroupIcon },
  // { 
  //   name: 'Contact Us', 
  //   description: 'Reach out to us for collaboration, support, or any inquiries regarding our services.', 
  //   href: '/contact', 
  //   icon: PhoneIcon // Update icon to EnvelopeIcon to represent contact
  // },
  // { name: 'Partners', description: 'Collaborate with industry leaders who share our vision of innovation and growth.', href: '/aboutus/partners', icon: GlobeAltIcon },
  // // {
  //   name: 'Careers',
  //   description: 'Join our innovative team and help shape the future with AI-driven solutions and cutting-edge technology.',
  //   href: '#',
  //   icon: IdentificationIcon, // Represents personal identity, job roles, and career opportunities
  // },
  // { name: 'Blogs', description: 'Latest articles and insights.', href: '/aboutus/blogs', icon: DocumentTextIcon },
  
];


// Example Data for 'About Us'
const aboutUs = [
  { name: 'Company Overview', 
    // description: 'Learn who we are, what we do, and how we’re transforming the future.', 
    href: '/aboutus/company-overview', icon: BuildingOfficeIcon },
  { name: 'Our Story', 
    // description: 'Discover how our journey began and what drives our passion for innovation and excellence.', 
    href: '/aboutus/our-story', icon: BookOpenIcon },
  { name: 'Our Team', 
    // description: 'Get to know the people behind our success.', 
    href: '/aboutus/our-team', icon: UserGroupIcon },
  { 
    name: 'Contact Us', 
    // description: 'Reach out to us for collaboration, support, or any inquiries regarding our services.', 
    href: '/contact', 
    icon: PhoneIcon // Update icon to EnvelopeIcon to represent contact
  },
  { name: 'Partners', 
    // description: 'Collaborate with industry leaders who share our vision of innovation and growth.', 
    href: '/aboutus/partners', icon: GlobeAltIcon },
  // {
  //   name: 'Careers',
  //   description: 'Join our innovative team and help shape the future with AI-driven solutions and cutting-edge technology.',
  //   href: '#',
  //   icon: IdentificationIcon, // Represents personal identity, job roles, and career opportunities
  // },
  { name: 'Blogs', 
    // description: 'Latest articles and insights.', 
    href: '/aboutus/blogs', icon: DocumentTextIcon },
  
];


// Example data for the lists and sublinks

const lists = [
  {
    name: 'Innovations', // Added ourIndustries
    sublinks: ourInnovations.map(industry => ({
      name: industry.name,
      href: industry.href
    })),
  },
  {
    name: 'Industries', // Added ourIndustries
    sublinks: ourIndustries.map(industry => ({
      name: industry.name,
      href: industry.href
    })),
  },
  {
    name:'Opportunity',
    sublinks: navigation.map(industry => ({
      name: industry.name,
      href: industry.href
    })),
  },
  // {
  //   name: 'Knowledge Hub', // Added knowledgeHub
  //   sublinks: knowledgeHub.map(hub => ({
  //     name: hub.name,
  //     href: hub.href
  //   })),
  // },
  {
    name: 'About Us', // Added aboutUs
    sublinks: aboutUs.map(about => ({
      name: about.name,
      href: about.href
    })),
  },
];


function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Navbar() {
  
const [activeDropdown, setActiveDropdown] = useState(null);
// Function to handle clicking on a list
const handleClick = (listName) => {
  if (activeDropdown === listName) {
    setActiveDropdown(null); // Collapse if already open
  } else {
    setActiveDropdown(listName); // Open the selected dropdown
  }
};

  return (
    <header>
    <Popover className="relative bg-white">
      <div className="flex justify-between items-center max-w-7xl mx-auto px-4 py-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8">
        <div className="flex justify-start lg:w-0 lg:flex-1">
          <Link to="/">
            <span className="sr-only">Genxz</span>
            <img
              className="h-8 w-auto sm:h-10"
              src={GenXZIcon}
              alt="Genxz"
            />
          </Link>
        </div>
        <div className="-mr-2 -my-2 md:hidden">
          <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
            <span className="sr-only">Open menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </Popover.Button>
        </div>
        <Popover.Group as="nav" className="hidden md:flex space-x-10">
          

        {/* Innovation Dropdown */}
          <Popover className="relative">
            {({ open }) => (
              <>
                  
                <Popover.Button
                  className={classNames(
                    open ? 'text-gray-900' : 'text-gray-500',
                    'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                  )}
                >
                  <span>Innovations</span>
                  <ChevronDownIcon
                    className={classNames(
                      open ? 'text-gray-600' : 'text-gray-400',
                      'ml-2 h-5 w-5 group-hover:text-gray-500'
                    )}
                    aria-hidden="true"
                  />
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                      <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                        {ourInnovations.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                          >
                            <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                              <item.icon className="h-6 w-6" aria-hidden="true" />
                            </div>
                            <div className="ml-4">
                              <p className="text-base font-medium text-gray-900">{item.name}</p>
                              <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>


          {/* Industries Dropdown */}
          <Popover className="relative">
            {({ open }) => (
              <>
                  
                <Popover.Button
                  className={classNames(
                    open ? 'text-gray-900' : 'text-gray-500',
                    'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                  )}
                >
                  <span>Industries</span>
                  <ChevronDownIcon
                    className={classNames(
                      open ? 'text-gray-600' : 'text-gray-400',
                      'ml-2 h-5 w-5 group-hover:text-gray-500'
                    )}
                    aria-hidden="true"
                  />
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                      <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                        {ourIndustries.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                          >
                            <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                              <item.icon className="h-6 w-6" aria-hidden="true" />
                            </div>
                            <div className="ml-4">
                              <p className="text-base font-medium text-gray-900">{item.name}</p>
                              <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>


          {/* Solutions Dropdown */}
          <Popover className="relative">
            {({ open }) => (
              <>
                <Popover.Button
                  className={classNames(
                    open ? 'text-gray-900' : 'text-gray-500',
                    'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                  )}
                >
                  <span>Solutions</span>
                  <ChevronDownIcon
                    className={classNames(
                      open ? 'text-gray-600' : 'text-gray-400',
                      'ml-2 h-5 w-5 group-hover:text-gray-500'
                    )}
                    aria-hidden="true"
                  />
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                      <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                        {solutions.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                          >
                            <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                              <item.icon className="h-6 w-6" aria-hidden="true" />
                            </div>
                            <div className="ml-4">
                              <p className="text-base font-medium text-gray-900">{item.name}</p>
                              <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>

          {navigation.map((item) => (
                    <Link key={item.name} to={item.href} className="text-base font-medium text-gray-500 hover:text-gray-900">
                      {item.name}
                    </Link>
                  ))}
            {/* Knowledge Hub Dropdown */}
            {/* <Popover className="relative">
            {({ open }) => (
              <>
                <Popover.Button
                  className={classNames(
                    open ? 'text-gray-900' : 'text-gray-500',
                    'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                  )}
                >
                  <span>Knowledge Hub</span>
                  <ChevronDownIcon
                    className={classNames(
                      open ? 'text-gray-600' : 'text-gray-400',
                      'ml-2 h-5 w-5 group-hover:text-gray-500'
                    )}
                    aria-hidden="true"
                  />
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                      <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                        {knowledgeHub.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                          >
                            <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                              <item.icon className="h-6 w-6" aria-hidden="true" />
                            </div>
                            <div className="ml-4">
                              <p className="text-base font-medium text-gray-900">{item.name}</p>
                              <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover> */}

          {/* About Us Dropdown */}
          <Popover className="relative">
            {({ open }) => (
              <>
                <Popover.Button
                  className={classNames(
                    open ? 'text-gray-900' : 'text-gray-500',
                    'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                  )}
                >
                  <span>About Us</span>
                  <ChevronDownIcon
                    className={classNames(
                      open ? 'text-gray-600' : 'text-gray-400',
                      'ml-2 h-5 w-5 group-hover:text-gray-500'
                    )}
                    aria-hidden="true"
                  />
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                      <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                        {aboutUs.map((item) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                          >
                            <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                              <item.icon className="h-6 w-6" aria-hidden="true" />
                            </div>
                            <div className="ml-4">
                              <p className="text-base font-medium text-gray-900">{item.name}</p>
                              <p className="mt-1 text-sm text-gray-500">{item.description}</p>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
{/* 
          <Link to="#" className="text-base font-medium text-gray-500 hover:text-gray-900">
            Pricing
          </Link>
          <Link to="#" className="text-base font-medium text-gray-500 hover:text-gray-900">
            Partners
          </Link>
          <Link to="#" className="text-base font-medium text-gray-500 hover:text-gray-900">
            Company
          </Link>*/}
        </Popover.Group>
        <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
          {/* <Link to="#" className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900">
            Sign in
          </Link>*/}
          <Link
            to="/contact"
            className="ml-8 whitespace-nowrap inline-flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white hover:from-purple-700 hover:to-indigo-700"
          >
            Request Demo
          </Link>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
          focus
          className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
        >
           {({ close }) => (
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <Link to="/" onClick={() => close()}>
                    <span className="sr-only">Genxz</span>
                        <img
                        className="h-8 w-auto"
                        src={GenXZIcon}
                        alt="Genxz"
                      />
                  </Link>
                  
                </div>
                <div className="-mr-2">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              <div className="mt-6">
                <nav className="grid grid-cols-1 gap-7">
                  {solutions.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                      onClick={() => close()}
                    >
                      <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                        <item.icon className="h-6 w-6" aria-hidden="true" />
                      </div>
                      <div className="ml-4 text-base font-medium text-gray-900">{item.name}</div>
                    </Link>
                  ))}
                </nav>
                {/* <nav className="grid grid-cols-1 gap-7 mt-10">
                  {solutions.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
                    >
                      <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                        <item.icon className="h-6 w-6" aria-hidden="true" />
                      </div>
                      <div className="ml-4 text-base font-medium text-gray-900">{item.name}</div>
                    </Link>
                  ))}
                </nav>
         */}
              </div>
            </div>

            <div className="py-6 px-5">
              <div className="space-y-4 w-full">
                {lists.map((list) => (
                  <div key={list.name} className="border-b pb-2">
                    {/* Main List Button */}
                    <button
                      className="text-base font-medium text-gray-900 hover:text-gray-700 w-full text-left flex justify-between items-center"
                      onClick={() => handleClick(list.name)}
                    >
                      {list.name}
                      <span className={`ml-2 transform transition-transform ${activeDropdown === list.name ? 'rotate-180' : ''}`}>
                        ▼
                      </span>
                    </button>

                    {/* Sub-links for the List */}
                    {activeDropdown === list.name && (
                      <div className="mt-2 ml-4 space-y-2">
                        {list.sublinks.map((sublink) => (
                          <Link
                            key={sublink.name}
                            to={sublink.href}
                            className="bg-white rounded-md inline-flex text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 w-full"
                            onClick={() => close()}
                          >
                            {sublink.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>


              <div className="mt-6">
                <Link
                  to="/contact"
                  className="w-full flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white hover:from-purple-700 hover:to-indigo-700"
                  onClick={() => close()}
                >
                  Request Demo
                </Link>
                {/* <p className="mt-6 text-center text-base font-medium text-gray-500">
                  Existing customer?{' '}
                  <Link to="#" className="text-gray-900">
                    Sign in
                  </Link>
                </p> */}
              </div>
            </div>
          </div>
           )}
        </Popover.Panel>
      </Transition>
    </Popover>
  </header>
  );
}
